const green26 = {
  50: '#fbfbf9',
  100: '#f4f3ec',
  200: '#e8e8d8',
  300: '#d9d8bf',
  400: '#c6c59f',
  500: '#b4b27e',
  600: '#a19e5e',
  700: '#817f4b',
  800: '#605f39',
  900: '#403f26',
  950: '#30301c',
}

const brown26 = {
  50: '#f8f6f3',
  100: '#efe9e2',
  200: '#ded1c3',
  300: '#c9b49f',
  400: '#b29178',
  500: '#a3785f',
  600: '#956753',
  700: '#7c5547',
  800: '#66473f',
  900: '#543d36',
  950: '#2e221f',
}

const sand26 = {
  50: '#fef8ee',
  100: '#fcf0d8',
  200: '#f7dbae',
  300: '#f2c37f',
  400: '#eca14b',
  500: '#e78528',
  600: '#d86d1e',
  700: '#b3531b',
  800: '#8f421d',
  900: '#74381a',
  950: '#481f0d',
}

const blue26 = {
  50: '#f9fafb',
  100: '#edf0f3',
  200: '#dae1e7',
  300: '#c2ced6',
  400: '#a3b5c2',
  500: '#859cad',
  600: '#668499',
  700: '#52697a',
  800: '#3d4f5c',
  900: '#29353d',
  950: '#1f282e',
}

const purple26 = {
  600: '#CC505F',
  900: '#8B202D',
}

const grey = {
  100: '#F4F2F5',
  200: '#E8E4EA',
  300: '#D6CED9',
  400: '#BDB0C2',
  1000: '#2D242E',
}

// const black = '#000000'
const white = '#FFFFFF'

const palette = {
  primary: sand26[300],
  primaryDark: blue26[950],
  primaryLight: blue26[100],
  secondary: blue26[500],
  secondaryLight: '#FBEEE4',
  third: '#848283',
  fourth: sand26[600],
  black: '#000000',
  white: '#FFFFFF',

  grey,
  green26,
  brown26,
  sand26,
  blue26,
  purple26,

  textGrey: blue26[950],

  border: grey[300],
}

const colors = {
  whiteDark: palette.secondaryLight,
  white: palette.white,

  backgroundDark: '#2b2b2b',
  backgroundBlack: palette.black,
  backgroundTransparent: '#252424cc',
  backgroundTransparent2: '#252424ee',

  text: palette.textGrey,
  textInverted: '#FFFFFF',
  textAlt: white,
  textForTitle: sand26[400],

  primary: green26[600],
  primaryDark: palette.primaryDark,
  secondary: palette.secondary,

  filtersBackground: palette.primaryDark,

  highlight: palette.fourth,
  favorite: '#645556',
  favoriteLight: '#433839',

  plusButton: sand26[300],
  plusButtonFavorite: sand26[950],
  plusButtonIcon: sand26[950],
  plusButtonIconFavorite: sand26[300],

  scrollUpButton: green26[600],
  scrollUpButtonActive: green26[700],

  Button: {
    background: sand26[300],
    backgroundOpen: sand26[50],
    text: sand26[950],
    textInverted: sand26[950],
  },

  Chip: {
    bg: palette.sand26[800],
  },

  SpecialContent: {
    bg: palette.sand26[900],
    bgSecondary: palette.sand26[950],
    divider: palette.sand26[500],
  },

  DayButtons: {
    containerBackground: palette.sand26[950],
    buttonBackground: palette.sand26[950],
    activeBg: palette.white,
    activeText: palette.textGrey,
    border: palette.primary,
  },

  Menu: {
    text: palette.white,
    active: {
      bg: palette.green26[50],
      text: palette.green26[950],
    },
    border: palette.green26[600],
  },

  Entry: {
    background: sand26[950],
    border: palette.sand26[500],
    floorItem: palette.sand26[500],
    favorite: {
      bg: palette.green26[50],
      text: palette.sand26[950],
      floorItem: palette.green26[500],
    },
    tag: sand26[500],
    profileIcon: palette.brown26[500],
    timeHeader: {
      background: palette.sand26[900],
      border: palette.sand26[500],
    },
  },

  Flat: {
    genres: {
      DJ: {
        even: palette.green26[800],
        odd: palette.green26[900],
      },
      'Live Act': {
        even: palette.green26[800],
        odd: palette.green26[900],
      },
      Band: {
        even: palette.green26[800],
        odd: palette.green26[900],
      },
      default: {
        even: palette.purple26[600],
        odd: palette.purple26[900],
      },
    },
    active: {
      background: palette.sand26[100],
    },
    currentTime: palette.green26[600],

    timeHeader: {
      background: palette.sand26[900],
      backgroundAlt: palette.sand26[950],
      border: sand26[700],

      active: {
        bg: palette.green26[600],
        text: '#F0F0F0',
      },
    },
  },

  Search: {
    textColor: sand26[950],
    background: blue26[50],
    closeIconBg: sand26[300],
    closeIconBgDisabled: sand26[200],
    closeIconText: sand26[950],
  },

  Filters: {
    titleBackground: palette.sand26[900],
    border: palette.brown26[500],
    Filter: {
      background: 'transparent',
      border: palette.primary,
      text: palette.white,
      textActive: palette.green26[950],
      backgroundActive: palette.green26[50],
    },
  },

  zIndex: {
    timeTable: 10,
    stickyStuff: 11,
    menu: 100,
    bottomArea: 101,
    timetableFlat: {
      timeHeader: 20,
      currentTimeLine: 19,
      stickyCorner: 30,
    },
  },

  error: {
    textColor: palette.secondary,
  },

  Map: {
    background: '#f3ebb9',
    text: '#2d242e',
    modal: {
      background: palette.green26[50],
      text: palette.black,
      overlay: 'rgba(1, 0, 0, 0.2)',
      darkBackground: palette.green26[950],
    },
    button: {
      background: palette.primaryDark,
      text: palette.white,
      active: palette.primary,
    },
  },
} as const

const space = [0, 4, 8, 12, 16, 24, 32]

export default colors

export { colors, space }
